import { FipsWarning } from '@@/FipsWarning';

interface Props {
  registryName?: string;
  docsUrl?: string;
}

export function RegistryFipsWarning({ registryName, docsUrl }: Props) {
  return (
    <FipsWarning docsUrl={docsUrl} docsLabel={registryName}>
      you are responsible for ensuring your registry endpoint is FIPS-compliant.
      {!docsUrl &&
        " Consult your registry's documentation for FIPS compliance information."}
    </FipsWarning>
  );
}
